<div class="foot-widgets four-col dark-sidebar " style="background-color: black;">
    <div class="foot-content clearfix  d-flex justify-content-center">
        <div class="w-75 ">
            <div class="row">
                <div class="col-12 col-md-3 mt-2">
                    <div id="media_image-8" class="widget widget_media_image"><img width="150" height="150"
                            src="assets/images/logo/logo-ampi.png"
                            class="image wp-image-15456  attachment-thumbnail size-thumbnail" alt="" decoding="async"
                            loading="lazy" style="max-width: 100%; height: auto;"></div>
                </div>
                <div class="col-12 col-md-3 mt-2">
                    <div id="text-17" class="widget widget_text">
                        <h4 class="title mb-1 " style="color: white; font-weight: bold;"><span>{{nameAssoc}}</span></h4>
                        <div class="textwidget">
                            <h5 style="color: #aaa;">68 AÑOS PROFESIONALIZANDO EL SECTOR INMOBILIARIO DE MÉXICO</h5>
                            <p>Una historia que se escribe día con día desde 1956</p>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-3 mt-2">
                    <div id="contact-info-3" class="widget widget_contact_info">
                        <h4 class="title mb-1" style="color: white; font-weight: bold;"><span> Contacto</span></h4>
                        <div class="info">
                            <div class="content-text" [innerHTML]="addressAssoc"></div>
                            <div class="phone with_icon mt-1" style="color: white;"><i class="fa fa-phone mr-1"></i>
                                {{phoneAssoc | slice:0:3
                                }}-{{phoneAssoc | slice:3:6
                                }}-{{phoneAssoc |
                                slice:6:10 }}</div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-3 mt-2">
                    <div id="nav_menu-10" class="widget widget_nav_menu">
                        <h4 class="title mb-1" style="color: white; font-weight: bold;"><span>Enlaces de Interés</span>
                        </h4>
                        <div class="menu-enlaces-de-interes-container">
                            <ul id="menu-enlaces-de-interes " class="menu">
                                <!-- <li id="menu-item-12178"
                                    class="menu-item menu-item-type-custom menu-item-object-custom menu-item-12178 mt-1">
                                    <a href="/aviso-de-privacidad" style="color:white;"><i
                                            class="fa fa-file-text-o mr-1"></i>AVISO DE
                                        PRIVACIDAD</a>
                                </li>
                                <li id="menu-item-12179"
                                    class="menu-item menu-item-type-custom menu-item-object-custom menu-item-12179 mt-1">
                                    <a href="#" style="color:white;"><i class="fa fa-book mr-1"></i>TÉRMINOS
                                        Y
                                        CONDICIONES</a>

                                </li> -->

                                <li id="menu-item-12179"
                                    class="menu-item menu-item-type-custom menu-item-object-custom menu-item-12179 mt-1">
                                    <a style="color:white;" (click)="redirectSN(5)"><i
                                            class="fa fa-user mr-1"></i>LOGIN</a>

                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

            </div>

            <div style="width: 100%; height: 2px; background-color: white;" class="mt-1"></div>

            <div class="row mt-1 ">
                <div class="col-12 mb-2">
                    <div class="foot-items">
                        <div class="foot-content clearfix">
                            <div class="row">
                                <div class="col-8">
                                    <div class="foot-text">{{nameAssoc}} © {{yearCurrent}}. Powered by <a
                                            href="https://inmoapp.mx/">INMOAPP</a>.</div>
                                </div>
                                <div class="col-4 d-flex justify-content-end">
                                    <div class="f-links">
                                        <div class="socials icons-only white white_hover "><a target="_blank"
                                                title="Facebook" class="a13_soc-facebook fa fa-facebook-square mr-3"
                                                rel="noopener" style="color:white; font-size: 30px;"
                                                (click)="redirectSN(1)" *ngIf="linkFace"></a><a target="_blank"
                                                title="Instagram" class="a13_soc-instagram fa fa-instagram mr-3"
                                                rel="noopener" style="color:white; font-size: 30px;"
                                                (click)="redirectSN(2)" *ngIf="linkInsta"></a><a target="_blank"
                                                title="YouTube" class="a13_soc-youtube fa fa-youtube-play mr-3"
                                                rel="noopener" style="color:white;  font-size: 30px;"
                                                (click)="redirectSN(3)" *ngIf="linkYou"></a>
                                            <a target="_blank" title="TikTok" rel="noopener" *ngIf="linkTik">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30"
                                                    fill="currentColor" class="bi bi-tiktok icons mr-2  pointerCursor"
                                                    viewBox="1 1 20 20" style="color: white; margin-bottom: 8px;">
                                                    <path
                                                        d="M9 0h1.98c.144.715.54 1.617 1.235 2.512C12.895 3.389 13.797 4 15 4v2c-1.753 0-3.07-.814-4-1.829V11a5 5 0 1 1-5-5v2a3 3 0 1 0 3 3V0Z"
                                                        (click)="redirectSN(4)" />
                                                </svg>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>




        </div>
    </div>

    <div class="contactBtn " style="z-index: 10;" *ngIf="bandWats">
        <div class="d-flex justify-content-center">
            <button type="button" class="btn btn-icon rounded-circle colorWhatsApp ml-1 m-0 " rippleEffect
                (click)="sendMessageWA()">
                <svg style="color: white" xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="currentColor"
                    class="whatsapp" viewBox="-1.5 -0.5 18 18">
                    <path
                        d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"
                        fill="white"></path>
                </svg>
            </button>
        </div>

    </div>


</div>